// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","637":"component---src-templates-blog-template-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"43874ad306815d5d5e2e","637":"70ba8ee970abb3e19342","678":"5b94d34e3c82eb12a427","883":"41336e7132e89d42bd65"}[chunkId] + ".js";
};